import React from 'react';

const CreateApplicationContext = React.createContext({});

export default CreateApplicationContext;
